import { storageService } from 'js/services/storage.service';

import * as helpers from './helpers';
import { LOG_TYPES, COLORS } from './constants';

export class LoggerService {
    /**
     * Log info to console
     * @param {String} type - either native `console` method or internal log type
     * @param {any} [message] - main log payload
     * @param {...any} [rest] - multiple params to native console method
     */
    log = (type, message, ...rest) => {
        if (this.isEnabled()) {
            this.handleMessage(type, message, ...rest);
        }
    };

    logGroup = (type, message, messages, ...rest) => {
        if (this.isEnabled()) {
            this.handleGroupMessage(type, message, ...rest);

            messages.forEach(element => {
                this.handleMessage(...element);
            });

            console.groupEnd();
        }
    };

    isEnabled() {
        return storageService.local.getItem('isLoggerEnabled');
    }

    isReduxEnabled() {
        return storageService.local.getItem('isReduxLoggerEnabled');
    }

    enableLogger() {
        storageService.local.setItem('isLoggerEnabled', true);
    }

    enableReduxLogger() {
        storageService.local.setItem('isReduxLoggerEnabled', true);
    }

    handleGroupMessage(type = 'Unknown', message, ...rest) {
        const logOptions = LOG_TYPES[type];

        if (!logOptions) {
            console.groupCollapsed(message, ...rest);

            return;
        }

        const [color = COLORS.unknownType,, title, parseMethod] = logOptions;

        console.groupCollapsed(...helpers[parseMethod](message, { color, title, type }));
    }

    handleMessage(type = 'Unknown', message, ...rest) {
        const logOptions = LOG_TYPES[type];

        if (!logOptions) {
            const method = console[type] || console.log;

            method.apply(console, [message, ...rest]);

            return;
        }

        const [color = COLORS.unknownType, typeMethod, title, parseMethod] = logOptions;
        const method = console[typeMethod] || console.log;

        method.apply(console, helpers[parseMethod](message, { color, title, type }));
    }
}

export const loggerService = new LoggerService();
